import posthog from "posthog-js"
import { useEffect, useState } from "react"
import { isRouteErrorResponse, useRouteError } from "react-router-dom"
import { posthogEnabled } from "~/components/providers/Posthog"
import {
	AppErrorScreen,
	describeUnknownError
} from "~/components/screens/AppErrorScreen"

export function ErrorBoundaryPage() {
	const error = useRouteError()
	const [errorId, setErrorId] = useState<string | null>(null)

	const isRouteResponse = isRouteErrorResponse(error)
	const message = isRouteResponse
		? `${error.status} ${error.statusText}`
		: "Something went wrong while loading this page."

	useEffect(() => {
		if (!posthogEnabled) return

		const exception = isRouteResponse ? new Error(message) : error
		const event = posthog.captureException(exception, {
			source: "react_router_error_boundary",
			path: window.location.pathname,
			...(isRouteResponse && {
				route_error_status: error.status,
				route_error_status_text: error.statusText
			})
		})
		setErrorId(event?.uuid ?? null)
	}, [error, isRouteResponse, message])

	return (
		<AppErrorScreen
			summary={message}
			errorId={errorId}
			details={[
				{
					label: "Boundary",
					value: "react_router_error_boundary"
				},
				{
					label: "Route error",
					value: isRouteResponse
						? {
								status: error.status,
								statusText: error.statusText,
								data: error.data
							}
						: describeUnknownError(error)
				}
			]}
		/>
	)
}
